import { authorizedFetch } from "./requestBuilder.js";

export const getAnalytics = async () => {
  try {
    return await authorizedFetch(
      `${process.env.REACT_APP_API_URL}/api/analytics`,
      {
        method: "GET",
      }
    );
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
};
